import { render, staticRenderFns } from "./AcceptWalletRequestModal.vue?vue&type=template&id=c46a6a96&scoped=true"
import script from "./AcceptWalletRequestModal.vue?vue&type=script&lang=js"
export * from "./AcceptWalletRequestModal.vue?vue&type=script&lang=js"
import style0 from "./AcceptWalletRequestModal.vue?vue&type=style&index=0&id=c46a6a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46a6a96",
  null
  
)

export default component.exports